import MetadataFormInDetail from "../../commons/FileEdit/components/MetadataFormInDetail";
import {
  MODAL_DELETE_FILE,
  MODAL_DELETE_FILE_FROM_MINIATURE,
  MODAL_DELETE_FOLDER,
  MODAL_END_LOAD,
  MODAL_METADATA_FORM_IN_DETAIL,
  MODAL_OBSERVATION,
  MODAL_UNLOCK_FOLDER,
  MODAL_VIEWER_IN_DETAIL,
} from "../../../store/Modals/constants";
import ViewerInDetail from "../../commons/FileEdit/components/ViewerInDetail";
import ObservationModal from "../PendingApproval/components/ObservationModal";
import React from "react";
import DeleteFolder from "../../commons/Modals/DeleteFolder";
import EndMetadataLoad from "../../commons/Modals/EndLoad";
import DeleteFile from "../../commons/Modals/DeleteFile";
import DeleteFileFromMiniature from "../../commons/Modals/DeleteFileFromMiniature";
import Unlock from "../../commons/Modals/Unlock";

export const MODALS = [
  { component: <MetadataFormInDetail />, id: MODAL_METADATA_FORM_IN_DETAIL },
  { component: <ViewerInDetail />, id: MODAL_VIEWER_IN_DETAIL },
  { component: <DeleteFolder />, id: MODAL_DELETE_FOLDER },
  { component: <ObservationModal />, id: MODAL_OBSERVATION },
  { component: <EndMetadataLoad />, id: MODAL_END_LOAD },
  { component: <DeleteFile />, id: MODAL_DELETE_FILE },
  { component: <Unlock />, id: MODAL_UNLOCK_FOLDER },
  {
    component: <DeleteFileFromMiniature />,
    id: MODAL_DELETE_FILE_FROM_MINIATURE,
  },
];
